import { revenueClient } from '../../utils/revenueClient';
import zonesClient, {
  zonesContainer,
  EspecialLambdaClient,
  historicalDealsClient,
  quotasClient,
  typologiesClient,
  approverClient,
  automationClient,
  wrapperZonesClient,
} from '../../utils/zonesClient';

export const getApprovalRules = async () => {
  const { data } = await zonesClient.get('approval-rules');
  return data;
};

export const putChangeRules = async (body: any) => {
  const { data } = await zonesClient.put('approval-rules', body);
  return data;
};

export const getApprovalRulesResume = async ({
  country,
  filter_by,
  ids,
  start_date,
  end_date,
  current_date,
}: any) => {
  const { data } = await zonesContainer.get('approval-rules/resume', {
    params: {
      country,
      filter_by,
      ids,
      start_date,
      end_date,
      current_date,
    },
  });
  return data;
};

export const getRuleDescriptionById = async ({
  country,
  filter_by,
  ids,
  start_date,
  end_date,
  current_date,
  id,
}: any) => {
  const { data } = await zonesContainer.get(`approval-rules/${id}`, {
    params: {
      country,
      filter_by,
      ids,
      start_date,
      end_date,
      current_date,
    },
  });
  return data;
};

export const getGlobalRulesFeatures = async () => {
  const { data } = await zonesClient.get('general-rules/attributes');
  return data;
};

export const getGeneralRulesByIds = async ({
  country,
  filter_by,
  ids,
}: any) => {
  const { data } = await zonesClient.get('general-rules', {
    params: {
      country,
      filter_by,
      ids,
    },
  });
  return data;
};

export const deleteGeneralRulesByIds = async ({
  rule_id,
  filter_by,
  ids,
  approval_rule_id,
}: any) => {
  const { data } = await zonesClient.delete('general-rules', {
    params: {
      rule_id,
      filter_by,
      ids,
      approval_rule_id,
    },
  });
  return data;
};

export const expandGeneralRulesByIds = async (
  country: string | null,
  body: any
) => {
  const { data } = await zonesClient.post(
    `${country}/general-rules/expand`,
    body
  );
  return data;
};

export const postGlobalRules = async (body: any) => {
  const country = localStorage.getItem('country');
  const { data } = await zonesClient.post(`${country}/general-rules`, body);
  return data;
};

export const getElevatorTypology = async ({ nids, country }: any) => {
  const countryParam = country || localStorage.getItem('country');
  const { data } = await wrapperZonesClient.get('api/approval/elevator_typology', {
    params: { nids, country: countryParam },
  });
  return data;
};

export const getApprovalRuleAdministration = async ({ country, nid }: any) => {
  const { data } = await wrapperZonesClient.get('api/approval/administration', {
    params: {
      country,
      nid,
    },
  });
  return data;
};

export const getGarageTypology = async ({ nid }: any) => {
  const country = localStorage.getItem('country');
  const { data } = await wrapperZonesClient.get('api/approval/garage_typology', {
    params: { nid, country },
  });
  return data;
};

export const getApprovalFloorElevator = async ({ country, nids }: any) => {
  const { data } = await wrapperZonesClient.get('api/approval/elevator', {
    params: {
      country,
      nids,
    },
  });
  return data;
};

export const getApprovalElevator = async ({ country, nid }: any) => {
  const { data } = await wrapperZonesClient.get('api/approval/elevator_typology', {
    params: {
      country,
      nid,
    },
  });
  return data;
};

export const getRevenue = async ({ country, nid }: any) => {
  const { data } = await EspecialLambdaClient.get('', {
    params: {
      country,
      nid,
    },
  });
  return data;
};

export const getHistoricalInfo = async ({ country, nid }: any) => {
  const { data } = await wrapperZonesClient.get('api/approval/historical-deals', {
    params: {
      country,
      nid,
    },
  });
  return data;
};

export const getBedroomBathroom = async ({ nid }: any) => {
  const country = localStorage.getItem('country');
  const { data } = await wrapperZonesClient.get('api/approval/typology/bedroom-vs-bathroom', {
    params: { nid, country },
  });
  return data;
};

export const getApprovalGoodZone = async ({ nid }: any) => {
  const country = localStorage.getItem('country');
  const { data } = await wrapperZonesClient.get('api/approval/good-zone', {
    params: { nid, country },
  });
  return data;
};

export const getApproval = async ({ nid, country }: any) => {
  const { data } = await approverClient.post(
    'approval',
    {},
    {
      params: {
        nid,
        country,
      },
    }
  );
  return data;
};

export const getHistoricalDeals = async ({ nid }: any) => {
  const { data } = await historicalDealsClient.get('get_negocios_historicos', {
    params: { nid },
  });
  return data;
};

export const getQuotas = async ({ nid }: any) => {
  const { data } = await quotasClient.get('get_cupos_nid', {
    params: {
      nid,
    },
  });
  return data;
};

export const putApproval = async (body: any) => {
  const country = body.country || localStorage.getItem('country');
  const { data } = await wrapperZonesClient.put('api/approval', body.params ?? body, {
    params: { country },
  });
  return data;
};

export const getRejectedReasons = async () => {
  const { data } = await zonesClient.get('approval/rejected_reasons', {
    params: {},
  });
  return data;
};

export const getRiskAlert = async (nids: string) => {
  const country = localStorage.getItem('country');
  const { data } = await wrapperZonesClient.get('api/approval/risk_alert', {
    params: { nids, country },
  });
  return data;
};

export const getCommitteePrice = async (nid: number) => {
  const country = localStorage.getItem('country');
  const { data } = await wrapperZonesClient.get('api/approval/committee-price', {
    params: { nid, country },
  });
  return data;
};

export const getPricingAccordingZone = async (nid: number) => {
  const country = localStorage.getItem('country');
  const { data } = await wrapperZonesClient.get('api/approval/pricing-according-to-zone', {
    params: { nid, country },
  });
  return data;
};

export const getFinalPrice = async (nids: string) => {
  const country = localStorage.getItem('country');
  const { data } = await wrapperZonesClient.get('api/approval/final-price', {
    params: { nids, country },
  });
  return data;
};

export const getBlacklist = async (nids: string) => {
  const country = localStorage.getItem('country');
  const { data } = await wrapperZonesClient.get('api/approval/blacklist', {
    params: { nids, country },
  });
  return data;
};

export const getPricingTrust = async ({ nid }: any) => {
  const country = localStorage.getItem('country');
  const { data } = await wrapperZonesClient.get('api/approval/pricing-trust', {
    params: { nid, country },
  });
  return data;
};

export const getRemo = async ({ nids }: any) => {
  const country = localStorage.getItem('country');
  const { data } = await wrapperZonesClient.get('api/approval/remo', {
    params: { nids, country },
  });
  return data;
};

export const getApprovalDiscountHesh = async ({ nid }: any) => {
  const country = localStorage.getItem('country');
  const { data } = await zonesContainer.get('approval/discount-hesh', {
    params: { nid, country },
  });
  return data;
};

export const getRevenueCategory = async ({ nid }: { nid: string | number }) => {
  const country = localStorage.getItem('country');

  const url =
    country === 'CO'
      ? '/get_revenue_price_co_apro'
      : '/get_revenue_price_mx_apro';

  const response = await revenueClient.get(url, {
    params: { nid },
  });

  const [{ Categoria, DiasProb, HesH, approval_result }] = response.data;
  return { Categoria, DiasProb, HesH, approval_result };
};

export const getPropertyTypologies = async ({ nid }: any) => {
  const response = await typologiesClient.get('/get_tipologias', {
    params: { nid },
  });
  return response;
};

export const getLemonLimit = async ({ nid }: any) => {
  const country = localStorage.getItem('country');
  const { data } = await approverClient.get('/reject_nid_lemon', {
    params: { nid, country },
  });
  return data;
};

export const getAutomation = async ({
  nid,
  country,
}: {
  nid: string;
  country: string;
}) => {
  const { data } = await automationClient.get('v1/nid/detail', {
    params: { nid, country },
  });
  return data;
};
